module.exports = __webpack_public_path__ + "img/type-e-scooter.b8e1d7f3.svg";